import React from "react";
import PropTypes from "prop-types";
import Logo from "./logo";
import Copyright from "./footer/footer-copyright";
import FooterWrapper from "./footer/footer-wrapper";
import { isMobileOnly } from "react-device-detect";

const DashboardFooter = ({ children, url, logoUrl, logoText, open }) => (
  <FooterWrapper open={open}>
    {!isMobileOnly && <Logo url={url} logoUrl={logoUrl} logoText={logoText} />}
    <Copyright />
  </FooterWrapper>
);

DashboardFooter.propTypes = {
  /**
   * Indica si el menú lateral del dashboard está desplegado
   **/
  open: PropTypes.bool,
  /**
   * Url del enlace del logo
   **/
  url: PropTypes.string,
  /**
   * Url de la imagen del logo
   **/
  logoUrl: PropTypes.string,
  /**
   * Texto alternativo de la imagen del logo
   **/
  logoText: PropTypes.string,
};

export default DashboardFooter;
